<template>
  <div>
      <el-container direction="vertical" style="height: 500px">
        <ul style="overflow: auto; margin-right: 20px">
          <el-descriptions :column="4" border style="margin-bottom: 10px">

            <el-descriptions-item span="4" label="联系人姓名">
              <div>{{ contactData.contactName }}</div>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="关系">
              <div>{{ contactData.relationName }}</div>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="联系人电话">
              <div>{{ contactData.contactPhone }}</div>
            </el-descriptions-item>
            <el-descriptions-item span="4" label="创建时间">
              <div>{{ contactData.createTime }}</div>
            </el-descriptions-item>
          </el-descriptions>
        </ul>
      </el-container>
  </div>
</template>

<script>
export default {
  props: {
    contactData: {
      typeof: Object,
      default: null,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {
    console.log(this.contactData, "表格子组件传值");
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
</style>